var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6685 2C10.9617 2 10.2839 2.28076 9.78414 2.78052L2.18062 10.384C2.06497 10.4997 2 10.6565 2 10.8201V13.7167C2 14.0572 2.27609 14.3333 2.61667 14.3333H5.51325C5.6768 14.3333 5.83365 14.2684 5.9493 14.1527L13.5528 6.5492C14.0526 6.04944 14.3333 5.37162 14.3333 4.66486C14.3333 3.95809 14.0526 3.28028 13.5528 2.78052C13.0531 2.28076 12.3752 2 11.6685 2ZM10.6562 3.65262C10.9247 3.38415 11.2888 3.23333 11.6685 3.23333C12.0481 3.23333 12.4123 3.38415 12.6807 3.65262C12.9492 3.92108 13.1 4.28519 13.1 4.66486C13.1 5.04452 12.9492 5.40864 12.6807 5.6771L12.3812 5.97659C12.3588 5.94268 12.3326 5.91049 12.3027 5.88062L10.4527 4.03062C10.4228 4.00074 10.3907 3.97457 10.3567 3.95211L10.6562 3.65262ZM9.50211 4.80675L3.23333 11.0755V13.1H5.25781L11.5266 6.83123C11.4927 6.80876 11.4605 6.78259 11.4306 6.75272L9.58062 4.90272C9.55074 4.87284 9.52457 4.84066 9.50211 4.80675Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.22906e9e3fbff912fd7f63ad36c62baf.svg";
export { ForwardRef as ReactComponent };